module.exports = __webpack_public_path__ + "img/quotation.b2b3e440.png";